import { render } from "./PropertyPage.vue?vue&type=template&id=7636a376"
import script from "./PropertyPage.vue?vue&type=script&lang=js"
export * from "./PropertyPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__